import React from "react";
import { Dialog, Button } from "@mui/material";
import { Translate } from "orion-components/i18n";

const ConfirmEvacuationDialog = ({ confirmReset, handleEvacuationToggle, setConfirmReset }) => {
	return (
		<Dialog open={confirmReset} PaperProps={{ className: "confirm-evacuation-dialog" }} data-testid="orion-components-shared-components-evacuation-accountability-components-confirm-evacuation-dialog-dialog">
			<div className="section1" data-testid="orion-components-shared-components-evacuation-accountability-components-confirm-evacuation-dialog-div">
				<div className="section1Child1" data-testid="orion-components-shared-components-evacuation-accountability-components-confirm-evacuation-dialog-div-2">
					<div className="section1Child2" data-testid="orion-components-shared-components-evacuation-accountability-components-confirm-evacuation-dialog-div-3">
						<div className="section1Child3" data-testid="orion-components-shared-components-evacuation-accountability-components-confirm-evacuation-dialog-div-4">
							<Translate value="global.sharedComponents.evacuationAccountability.components.confirmEvacuationDialog.title" />
						</div>
						<div className="section1Child4" data-testid="orion-components-shared-components-evacuation-accountability-components-confirm-evacuation-dialog-div-5">
							<Translate value="global.sharedComponents.evacuationAccountability.components.confirmEvacuationDialog.message" />
						</div>
					</div>

					<div className="section2" data-testid="orion-components-shared-components-evacuation-accountability-components-confirm-evacuation-dialog-div-6">
						<Button className="section2Child1" onClick={() => setConfirmReset(false)} data-testid="orion-components-shared-components-evacuation-accountability-components-confirm-evacuation-dialog-button">
							<Translate value="global.sharedComponents.evacuationAccountability.components.confirmEvacuationDialog.cancel" />
						</Button>
						<Button className="section2Child2" onClick={handleEvacuationToggle} data-testid="orion-components-shared-components-evacuation-accountability-components-confirm-evacuation-dialog-button-2">
							<Translate value="global.sharedComponents.evacuationAccountability.components.confirmEvacuationDialog.confirm" />
						</Button>
					</div>
				</div>
			</div>
		</Dialog>
	);
};

export default ConfirmEvacuationDialog;
